<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
	<rect width="18" height="18" transform="translate(0.5)" fill="white" fill-opacity="0.01" />
	<path
		d="M9.5 14.25V3.75"
		stroke="white"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M4.25 9L9.5 3.75L14.75 9"
		stroke="white"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
</svg>
